package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * Phase 4：单个 keybinding 条目 AST。
 *
 * - [id]：绑定标识符（如 "openSkillPanel"）
 * - [defaultKey]：默认按键（可空；支持简化名 "P" / GLFW 键名 "key.keyboard.p" / 数值 "295"）
 * - [label]：ControlsScreen 中显示的名称（可空；支持翻译键或直接文本）
 * - [onTrigger]：触发时执行的语句列表
 */
data class KeyBindingAst(
    val id: String,
    val defaultKey: String? = null,
    val label: String? = null,
    val onTrigger: List<StmtAst>,
    override val position: SourcePosition,
) : AstNode
